import React from 'react';
import onClickOutside from 'react-onclickoutside';
import styles from './WithConfirm.module.scss';
import {
  If,
  RelativeBox,
  ClickableBox,
  Paragraph,
  SpacingBox,
  FlexBox,
  Bold,
} from '.';

export class WithConfirmComponent extends React.PureComponent {
  state = {
    confirmOpen: false,
  };

  handleClickOutside = () => this.setConfirmOpen(false);

  setConfirmOpen = (confirmOpen) => this.setState({ confirmOpen });

  render() {
    const { confirmOpen } = this.state;
    const { setConfirmOpen } = this;
    const { onClick, children } = this.props;

    const onClickWithConfirm = () => setConfirmOpen(true);

    return (
      <RelativeBox>
        <If condition={!!confirmOpen}>
          {() => (
            <div className={styles.withConfirm}>
              <FlexBox flexDirection="column">
                <Bold>Are you sure?</Bold>
                <FlexBox>
                  <ClickableBox onClick={() => setConfirmOpen(false)}>
                    <Paragraph>Cancel</Paragraph>
                  </ClickableBox>
                  <SpacingBox marginLeft="sm">
                    <ClickableBox onClick={onClick}>
                      <Paragraph>OK</Paragraph>
                    </ClickableBox>
                  </SpacingBox>
                </FlexBox>
              </FlexBox>
            </div>
          )}
        </If>
        {children(onClickWithConfirm)}
      </RelativeBox>
    );
  }
}

export const WithConfirm = onClickOutside(WithConfirmComponent);
